import React from "react";

const Loader = ({ children, className }) => {
  return <div className={`loader ${className || ""}`}>{children}</div>;
};

export default Loader;
